<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_product_category") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.category_image')"
            @selectImage="selectImage"
            required
          />

          <!-- Start:: Ar Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            required
          />
          <!-- End:: Ar Name Input -->

          <!-- Start:: En Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            required
          />
          <!-- End:: En Name Input -->

          <!-- Start:: Provider Input -->
          <base-select-input
            col="12"
            :optionsList="allProviders"
            :placeholder="$t('SIDENAV.OffersManagement.providerName')"
            v-model="data.selectedProviders"
            multiple
            required
          />
          <!-- End:: Provider Input -->

          <!-- Start:: Activation Status Input -->
          <base-select-input
            col="12"
            :optionsList="activationStatuses"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model="data.active"
            required
          />
          <!-- End:: Activation Status Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "EditProductCategories",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        selectedProviders: [],
        active: null,
      },
      // End:: Data Collection To Send

      allProviders: [], // This should be populated with the list of providers
      activationStatuses: [
        { id: 1, name: this.$t("PLACEHOLDERS.active"), value: 1 },
        { id: 0, name: this.$t("PLACEHOLDERS.notActive"), value: 0 },
      ],
    };
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories/${this.$route.params.id}`,
        });
        // Start:: Set Data
        this.data.image.path = res.data.data?.Category.file_path;
        this.data.nameAr = res.data.data?.Category.name_ar;
        this.data.nameEn = res.data.data?.Category.name_en;
        this.data.selectedProviders = res.data.data?.Category.users;
        this.data.active = {
          id: res.data.data?.Category.is_active ? 1 : 0,
          name: res.data.data?.Category.is_active
            ? this.$t("PLACEHOLDERS.active")
            : this.$t("PLACEHOLDERS.notActive"),
          value: res.data.data?.Category.is_active,
        };
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (this.data.active === null) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.status"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.image.file) {
        REQUEST_DATA.append("file_path", this.data.image.file);
      }
      // Start:: Append Request Data
      REQUEST_DATA.append("name[ar]", this.data.nameAr);
      REQUEST_DATA.append("name[en]", this.data.nameEn);
      this.data.selectedProviders.forEach((providerId) => {
        REQUEST_DATA.append("user_ids[]", providerId?.id);
      });
      if (this.data.active !== null) {
        REQUEST_DATA.append("is_active", this.data.active?.value);
      }
      REQUEST_DATA.append("_method", "PUT");
      // End:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `categories/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/product-categories/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods

    // Fetch providers here and populate allProviders
    try {
      const response = await this.$axios.get("providers?page=0&limit=0", {
        params: {
          is_allowed: 1,
        },
      });
      this.allProviders = response.data.data.data;
    } catch (error) {
      console.error("Error fetching providers:", error);
    }
  },
};
</script>
